import { PurchaseOrder, HandlingUnit, PurchaseOrderStatus } from '../../../types/purchaseOrder';
import { EditablePurchaseOrderItem, FormState } from './types';

export function convertToFormState(purchaseOrder: PurchaseOrder): FormState {
  return {
    id: purchaseOrder.id,
    poNumber: purchaseOrder.poNumber,
    status: purchaseOrder.status,
    clientId: purchaseOrder.clientId,
    client: purchaseOrder.client,
    createdAt: purchaseOrder.createdAt,
    updatedAt: purchaseOrder.updatedAt,
    approvedAt: purchaseOrder.approvedAt,
    rejectedAt: purchaseOrder.rejectedAt,
    completedAt: purchaseOrder.completedAt,
    notes: purchaseOrder.notes,
    internalNotes: purchaseOrder.internalNotes,
    sentToQuickbooks: purchaseOrder.sentToQuickbooks,
    quickbooksInvoiceId: purchaseOrder.quickbooksInvoiceId,
    history: purchaseOrder.history,
    pdfPath: purchaseOrder.pdfPath,
    items: purchaseOrder.items
      .map(item => ({
        ...item,
        product: item.product,
        handlingUnits: item.handlingUnits || [],
        hu: item.hu || []
      }))
      .sort((a, b) =>
        (parseInt(a.itemNumber, 10) || 0) - (parseInt(b.itemNumber, 10) || 0)
      )
  };
}

export function convertToPurchaseOrderItem(item: EditablePurchaseOrderItem) {
  return {
    id: item.id || 0,
    itemNumber: item.itemNumber,
    material: item.material,
    quantity: item.quantity,
    unitPrice: item.unitPrice,
    unit: item.unit,
    currency: item.currency,
    shipToParty: item.shipToParty,
    batchNumber: item.batchNumber,
    stage: item.stage,
    deliveryDate: item.deliveryDate,
    handlingUnits: item.handlingUnits.map(hu => ({
      id: hu.id || 0,
      huNumber: hu.huNumber,
      stage: hu.stage,
      deliveryDate: hu.deliveryDate,
      location: hu.location,
      receivedCount: hu.receivedCount,
      purchaseOrderItemId: hu.purchaseOrderItemId
    })),
    hu: item.hu
  };
}

export function convertHandlingUnitForUpdate(hu: HandlingUnit) {
  return {
    id: hu.id || 0,
    huNumber: hu.huNumber,
    stage: hu.stage,
    deliveryDate: hu.deliveryDate,
    location: hu.location,
    receivedCount: hu.receivedCount,
    purchaseOrderItemId: hu.purchaseOrderItemId
  };
}
